var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "form",
      {
        staticClass: "m-form m-form--state",
        attrs: { "data-vv-scope": "authorization" + _vm.idx }
      },
      [
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "authorization" +
                          _vm.idx +
                          ".identification_number_" +
                          _vm.idx
                      )
                    },
                    "col-lg-3"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "identification_number_" + _vm.idx } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("identification_number")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.auto.identification_number,
                        expression: "auto.identification_number"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|numeric|min:4|max:15",
                        expression: "'required|numeric|min:4|max:15'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      "data-vv-as": "identification_number",
                      id: "identification_number_" + _vm.idx,
                      name: "identification_number_" + _vm.idx,
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_identification_number")
                      ),
                      readonly: _vm.edit
                    },
                    domProps: { value: _vm.auto.identification_number },
                    on: {
                      keyup: function($event) {
                        return _vm.uniqueIdentificationNumber(
                          _vm.auto.identification_number,
                          _vm.idx
                        )
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.auto,
                          "identification_number",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" +
                              _vm.idx +
                              ".identification_number_" +
                              _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.identification_number_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "identification_number",
                              _vm.errors.first(
                                "authorization" +
                                  _vm.idx +
                                  ".identification_number_" +
                                  _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-3",
                  class: {
                    "has-danger": _vm.errors.has(
                      "authorization" +
                        _vm.idx +
                        ".identification_type_" +
                        _vm.idx
                    )
                  }
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "identification_type_" + _vm.idx } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("identification_type")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.auto.identification_type,
                          expression: "auto.identification_type"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: {
                        "form-control": true,
                        error: _vm.errors.has("identification_type_" + _vm.idx)
                      },
                      attrs: {
                        "data-vv-as": "identification_type",
                        id: "identification_type_" + _vm.idx,
                        name: "identification_type_" + _vm.idx
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.auto,
                            "identification_type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("select_an_option")
                              )
                            ) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.identification_types, function(
                        identification
                      ) {
                        return _c(
                          "option",
                          {
                            key: identification.id,
                            domProps: { value: identification.id }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(identification.name) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" +
                              _vm.idx +
                              ".identification_type_" +
                              _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.identification_type_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "identification_type",
                              _vm.errors.first(
                                "authorization" +
                                  _vm.idx +
                                  ".identification_type_" +
                                  _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "authorization" + _vm.idx + ".first_name_" + _vm.idx
                      )
                    },
                    "col-lg-3"
                  ]
                },
                [
                  _c("label", { attrs: { for: "first_name_" + _vm.idx } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("first_name"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.auto.first_name,
                        expression: "auto.first_name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces|min:2|max:50",
                        expression: "'required|alpha_spaces|min:2|max:50'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": "first_name",
                      type: "text",
                      id: "first_name_" + _vm.idx,
                      name: "first_name_" + _vm.idx,
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_first_name")
                      )
                    },
                    domProps: { value: _vm.auto.first_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.auto, "first_name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" + _vm.idx + ".first_name_" + _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.first_name_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "first_name",
                              _vm.errors.first(
                                "authorization" +
                                  _vm.idx +
                                  ".first_name_" +
                                  _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "authorization" + _vm.idx + ".last_name_" + _vm.idx
                      )
                    },
                    "col-lg-3"
                  ]
                },
                [
                  _c("label", { attrs: { for: "last_name_" + _vm.idx } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("last_name"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.auto.last_name,
                        expression: "auto.last_name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces|min:2|max:50",
                        expression: "'required|alpha_spaces|min:2|max:50'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": "last_name",
                      type: "text",
                      id: "last_name_" + _vm.idx,
                      name: "last_name_" + _vm.idx,
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_last_name")
                      )
                    },
                    domProps: { value: _vm.auto.last_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.auto, "last_name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" + _vm.idx + ".last_name_" + _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.last_name_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "last_name",
                              _vm.errors.first(
                                "authorization" +
                                  _vm.idx +
                                  ".last_name_" +
                                  _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form___group row" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.group_register,
                      expression: "!group_register"
                    }
                  ],
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "authorization" + _vm.idx + ".start_date_" + _vm.idx
                      )
                    },
                    "col-lg-3"
                  ]
                },
                [
                  _c("label", { attrs: { for: "start_date_" + _vm.idx } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("start_date"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("s-date-time-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      id: "start_date_" + _vm.idx,
                      "data-vv-as": "start_date",
                      name: "start_date_" + _vm.idx,
                      options: _vm.config.start,
                      placeholder: "AAAA-MM-DD"
                    },
                    on: {
                      empty: function($event) {
                        _vm.auto.start_date = $event
                      },
                      input: function($event) {
                        return _vm.startDate(_vm.idx, _vm.auto.start_date)
                      }
                    },
                    model: {
                      value: _vm.auto.start_date,
                      callback: function($$v) {
                        _vm.$set(_vm.auto, "start_date", $$v)
                      },
                      expression: "auto.start_date"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" + _vm.idx + ".start_date_" + _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.start_date_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "start_date",
                              _vm.errors.first(
                                "authorization" +
                                  _vm.idx +
                                  ".start_date_" +
                                  _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.group_register,
                      expression: "!group_register"
                    }
                  ],
                  staticClass: "col-lg-3"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "m-checkbox-inline m-checkbox-inline-form-wizard"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "m-checkbox checkbox-form-wizard" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("capitalize")("undefined_date")) +
                              "\n                "
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.auto.undefined_date,
                                expression: "auto.undefined_date"
                              }
                            ],
                            attrs: { type: "checkbox", name: "undefined" },
                            domProps: {
                              checked: Array.isArray(_vm.auto.undefined_date)
                                ? _vm._i(_vm.auto.undefined_date, null) > -1
                                : _vm.auto.undefined_date
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.auto.undefined_date,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.auto,
                                        "undefined_date",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.auto,
                                        "undefined_date",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.auto, "undefined_date", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span")
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.group_register && !_vm.auto.undefined_date,
                      expression: "!group_register && !auto.undefined_date"
                    }
                  ],
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "authorization" + _vm.idx + ".end_date_" + _vm.idx
                      )
                    },
                    "col-lg-3"
                  ]
                },
                [
                  _c("label", { attrs: { for: "end_date_" + _vm.idx } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("end_date"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("s-date-time-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      id: "end_date_" + _vm.idx,
                      name: "end_date_" + _vm.idx,
                      "data-vv-as": "end_date",
                      options: _vm.config.end,
                      placeholder: "AAAA-MM-DD"
                    },
                    on: {
                      empty: function($event) {
                        _vm.auto.end_date = $event
                      }
                    },
                    model: {
                      value: _vm.auto.end_date,
                      callback: function($$v) {
                        _vm.$set(_vm.auto, "end_date", $$v)
                      },
                      expression: "auto.end_date"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" + _vm.idx + ".end_date_" + _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.end_date_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "end_date",
                              _vm.errors.first(
                                "authorization" +
                                  _vm.idx +
                                  ".end_date_" +
                                  _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "authorization" + _vm.idx + ".email_" + _vm.idx
                      )
                    },
                    "col-lg-3"
                  ]
                },
                [
                  _c("label", { attrs: { for: "email_" + _vm.idx } }, [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("email")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.auto.email,
                        expression: "auto.email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value:
                          _vm.auto.is_responsible || _vm.auto.is_operator
                            ? "required|email|min:5|max:100|uniqueEmail"
                            : _vm.auto.biometric
                            ? "required|email|min:5|max:100|uniqueEmail"
                            : "email|min:5|max:100|uniqueEmail",
                        expression:
                          "auto.is_responsible || auto.is_operator ? 'required|email|min:5|max:100|uniqueEmail' : auto.biometric ? 'required|email|min:5|max:100|uniqueEmail' : 'email|min:5|max:100|uniqueEmail'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": "email",
                      type: "text",
                      id: "email_" + _vm.idx,
                      name: "email_" + _vm.idx,
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_email")
                      )
                    },
                    domProps: { value: _vm.auto.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.auto, "email", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" + _vm.idx + ".email_" + _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.email_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "email",
                              _vm.errors.first(
                                "authorization" + _vm.idx + ".email_" + _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "authorization" + _vm.idx + ".observations_" + _vm.idx
                      )
                    },
                    "col-lg-6"
                  ]
                },
                [
                  _c("label", { attrs: { for: "observations_" + _vm.idx } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("observations")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.auto.observations,
                        expression: "auto.observations"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "min:5|max:200",
                        expression: "'min:5|max:200'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": "observations",
                      id: "observations_" + _vm.idx,
                      name: "observations_" + _vm.idx,
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_observation")
                      )
                    },
                    domProps: { value: _vm.auto.observations },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.auto, "observations", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "authorization" +
                              _vm.idx +
                              ".observations_" +
                              _vm.idx
                          ),
                          expression:
                            "errors.has(`authorization${idx}.observations_${idx}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "observations",
                              _vm.errors.first(
                                "authorization" +
                                  _vm.idx +
                                  ".observations_" +
                                  _vm.idx
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-3" }, [
                _c("label", [_vm._v(" ")]),
                _c("br"),
                _vm._v(" "),
                _c("label", [_vm._v(" ")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.messageCredentialTooltip,
                        expression: "messageCredentialTooltip"
                      }
                    ],
                    class: [
                      { "btn-primary": !_vm.credentialErrors },
                      { "btn-danger": _vm.credentialErrors },
                      "buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill"
                    ],
                    attrs: {
                      href: "",
                      "data-toggle": "modal",
                      "data-backdrop": "static",
                      "data-keyboard": "false",
                      "data-target": "#add_credentials_modal"
                    },
                    on: {
                      click: function($event) {
                        return _vm.addCredential(_vm.idx)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-address-card" }),
                    _vm._v(" "),
                    _vm.auto.authorized_credentials.length > 0
                      ? _c(
                          "span",
                          { staticClass: "badge badge-notification" },
                          [
                            _vm._v(
                              _vm._s(_vm.auto.authorized_credentials.length)
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("label", [_vm._v(" ")]),
                _vm._v(" "),
                _vm.showExpirations &&
                !_vm.group_register &&
                !_vm.auto.undefined_date
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.messageDocumentTooltip,
                            expression: "messageDocumentTooltip"
                          }
                        ],
                        class: [
                          { "btn-primary": !_vm.expirationErrors },
                          { "btn-danger": _vm.expirationErrors },
                          "buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill"
                        ],
                        attrs: {
                          href: "",
                          "data-toggle": "modal",
                          "data-backdrop": "static",
                          "data-keyboard": "false",
                          "data-target": "#add_expiration_modal"
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-calendar-times-o" }),
                        _vm._v(" "),
                        _vm.auto.doc_types.length > 0
                          ? _c(
                              "span",
                              { staticClass: "badge badge-notification" },
                              [_vm._v(_vm._s(_vm.auto.doc_types.length))]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form___group" }, [
              _c(
                "div",
                {
                  staticClass: "form-group m-form___group row details_container"
                },
                [
                  _vm.authorized_type_id !== 1
                    ? _c(
                        "div",
                        {
                          class: [
                            {
                              "has-danger": _vm.errors.has(
                                "authorization" +
                                  _vm.idx +
                                  ".company_origin_" +
                                  _vm.idx
                              )
                            },
                            "col-lg-3"
                          ]
                        },
                        [
                          _c(
                            "label",
                            { attrs: { for: "company_origin_" + _vm.idx } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("company_origin")
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.auto.company_origin,
                                expression: "auto.company_origin"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value:
                                  _vm.authorized_type_id === 2
                                    ? "min:2|max:100|required"
                                    : "min:2|max:100",
                                expression:
                                  "authorized_type_id === 2 ? 'min:2|max:100|required' : 'min:2|max:100'"
                              }
                            ],
                            staticClass: "form-control m-input",
                            attrs: {
                              "data-vv-as": "company_origin",
                              type: "text",
                              id: "company_origin_" + _vm.idx,
                              name: "company_origin_" + _vm.idx,
                              placeholder: _vm._f("capitalize")(
                                _vm._f("translate")("enter_company_origin")
                              )
                            },
                            domProps: { value: _vm.auto.company_origin },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.auto,
                                  "company_origin",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "authorization" +
                                      _vm.idx +
                                      ".company_origin_" +
                                      _vm.idx
                                  ),
                                  expression:
                                    "errors.has(`authorization${idx}.company_origin_${idx}`)"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.translateErrorMessage(
                                      "company_origin",
                                      _vm.errors.first(
                                        "authorization" +
                                          _vm.idx +
                                          ".company_origin_" +
                                          _vm.idx
                                      )
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group m-form___group row" }, [
                _vm.showVisited
                  ? _c("div", { staticClass: "form-control checks col-lg-3" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "m-checkbox-list m-checkbox-inline-form-wizard"
                        },
                        [
                          _c("label", { staticClass: "m-checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.auto.is_responsible,
                                  expression: "auto.is_responsible"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.auto.is_responsible)
                                  ? _vm._i(_vm.auto.is_responsible, null) > -1
                                  : _vm.auto.is_responsible
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.auto.is_responsible,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.auto,
                                          "is_responsible",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.auto,
                                          "is_responsible",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.auto, "is_responsible", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("is_responsible")
                                  )
                                ) +
                                "\n                  "
                            ),
                            _c("span")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showOperator
                  ? _c("div", { staticClass: "form-control checks col-lg-3" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "m-checkbox-list m-checkbox-inline-form-wizard"
                        },
                        [
                          _c("label", { staticClass: "m-checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.auto.is_operator,
                                  expression: "auto.is_operator"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.auto.is_operator)
                                  ? _vm._i(_vm.auto.is_operator, null) > -1
                                  : _vm.auto.is_operator
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.auto.is_operator,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.auto,
                                          "is_operator",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.auto,
                                          "is_operator",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.auto, "is_operator", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("is_operator")
                                  )
                                ) +
                                "\n                  "
                            ),
                            _c("span")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showOwnFleet
                  ? _c("div", { staticClass: "form-control checks col-lg-3" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "m-checkbox-list m-checkbox-inline-form-wizard"
                        },
                        [
                          _c("label", { staticClass: "m-checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.auto.own_fleet,
                                  expression: "auto.own_fleet"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.auto.own_fleet)
                                  ? _vm._i(_vm.auto.own_fleet, null) > -1
                                  : _vm.auto.own_fleet
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.auto.own_fleet,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.auto,
                                          "own_fleet",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.auto,
                                          "own_fleet",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.auto, "own_fleet", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("is_own_fleet")
                                  )
                                ) +
                                "\n                  "
                            ),
                            _c("span")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showBiometric == "true",
                        expression: "showBiometric == 'true'"
                      }
                    ],
                    staticClass: "form-control checks col-lg-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "m-checkbox-list m-checkbox-inline-form-wizard"
                      },
                      [
                        _c("label", { staticClass: "m-checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.auto.biometric,
                                expression: "auto.biometric"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.auto.biometric)
                                ? _vm._i(_vm.auto.biometric, null) > -1
                                : _vm.auto.biometric
                            },
                            on: {
                              click: function($event) {
                                return _vm.checkBiometricsMail(_vm.auto.email)
                              },
                              change: function($event) {
                                var $$a = _vm.auto.biometric,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.auto,
                                        "biometric",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.auto,
                                        "biometric",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.auto, "biometric", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("biometric")
                                )
                              ) +
                              "\n                  "
                          ),
                          _c("span")
                        ])
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group m-form__group row container-hide" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.auto.is_responsible,
                          expression: "auto.is_responsible"
                        }
                      ],
                      class: [
                        {
                          "has-danger": _vm.errors.has(
                            "authorization" + _vm.idx + ".position_" + _vm.idx
                          )
                        },
                        "col-lg-3"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "position_" + _vm.idx } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("position")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.auto.position,
                            expression: "auto.position"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_spaces|min:5|max:30",
                            expression: "'alpha_spaces|min:5|max:30'"
                          }
                        ],
                        staticClass: "form-control m-input",
                        attrs: {
                          "data-vv-as": "position",
                          type: "text",
                          id: "position_" + _vm.idx,
                          name: "position_" + _vm.idx,
                          placeholder: _vm._f("capitalize")(
                            _vm._f("translate")("enter_position")
                          ),
                          readonly: _vm.edit && _vm.auto.position !== ""
                        },
                        domProps: { value: _vm.auto.position },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.auto, "position", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has(
                                "authorization" +
                                  _vm.idx +
                                  ".position_" +
                                  _vm.idx
                              ),
                              expression:
                                "errors.has(`authorization${idx}.position_${idx}`)"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.translateErrorMessage(
                                  "position",
                                  _vm.errors.first(
                                    "authorization" +
                                      _vm.idx +
                                      ".position_" +
                                      _vm.idx
                                  )
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.auto.is_operator,
                          expression: "auto.is_operator"
                        }
                      ],
                      class: [
                        {
                          "has-danger": _vm.errors.has(
                            "authorization" +
                              _vm.idx +
                              ".profile_operator_" +
                              _vm.idx
                          )
                        },
                        "col-lg-3"
                      ]
                    },
                    [
                      _c(
                        "label",
                        { attrs: { for: "profile_operator_" + _vm.idx } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("profile_operator")
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.auto.profile_operator,
                              expression: "auto.profile_operator"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.auto.is_operator ? "required" : "",
                              expression: "auto.is_operator ?'required' : ''"
                            }
                          ],
                          class: {
                            "form-control": true,
                            error: _vm.errors.has(
                              "authorization" +
                                _vm.idx +
                                ".profile_operator_" +
                                _vm.idx
                            )
                          },
                          attrs: {
                            "data-vv-as": "profile_operator",
                            id: "profile_operator_" + _vm.idx,
                            name: "profile_operator_" + _vm.idx
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.auto,
                                "profile_operator",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("select_an_option")
                                  )
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.profiles, function(profile) {
                            return _c(
                              "option",
                              {
                                key: profile.id,
                                domProps: { value: profile.id }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(profile.name) +
                                    "\n                "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has(
                                "authorization" +
                                  _vm.idx +
                                  ".profile_operator_" +
                                  _vm.idx
                              ),
                              expression:
                                "errors.has(`authorization${idx}.profile_operator_${idx}`)"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.translateErrorMessage(
                                  "profile_operator",
                                  _vm.errors.first(
                                    "authorization" +
                                      _vm.idx +
                                      ".profile_operator_" +
                                      _vm.idx
                                  )
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.validate_footer,
                expression: "validate_footer"
              }
            ],
            staticClass: "modal-footer"
          },
          [
            _c(
              "button",
              { staticClass: "btn btn-primary", attrs: { type: "button" } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("capitalize")(_vm._f("translate")("continue"))
                    ) +
                    "\n      "
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51397478", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51397478","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/cargo_authorization/FormContent.vue
// module id = 443
// module chunks = 0 1 7 30